import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';

import {AuthenticationService} from '../_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                const shouldTryRefresh = err.status === 401 && this.shouldTryRefresh(request);
                if (shouldTryRefresh) {
                    return this.authenticationService
                        .refreshToken(undefined, true).pipe(
                            switchMap(user =>next.handle(this.addToken(request, user.token))),
                            catchError(refreshError => {
                                this.authenticationService.logout();
                            return throwError(() => refreshError);
                            })
                        );
                }

                if (err.status === 401) {
                    this.authenticationService.logout();
                }

                return throwError(() => err.error || err);
            })
        );
    }

    private shouldTryRefresh(request: HttpRequest<any>): boolean {
        const url = request.url;
        return this.authenticationService.canRefreshToken() &&
            !url.includes('/auth/authenticate') &&
            !url.includes('/auth/token/refresh') &&
            !url.includes('/v2/auth/getOrCreateUser');
    }

    private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
        });
    }
}
